import TnCFieldLink from './TnCFieldLink'
export default TnCFieldLink
